import Accordion from 'accordion-js';
import pathSvg from '/img/icons.svg';

const accordions = document.querySelectorAll('[data-accordion]');

accordions.forEach(acc => {
  new Accordion(acc, {
    duration: 400,
    showMultiple: false,
  });

  acc.addEventListener('click', () => {
    setTimeout(updateAccordionIcons, 410);
  });
});

function updateAccordionIcons() {
  document.querySelectorAll('.ac').forEach(item => {
    const use = item.querySelector('.ac-icon use');
    if (!use) return;

    use.setAttribute(
      'href',
      item.classList.contains('is-active')
        ? `${pathSvg}#Ic-minus`
        : `${pathSvg}#Ic-plus`
    );
  });
}

updateAccordionIcons();
